module.exports = __webpack_public_path__ + "img/1.c59c12c1.png";